import { render, staticRenderFns } from "./PortcallinvoicesModals.vue?vue&type=template&id=18bf0223"
import script from "./PortcallinvoicesModals.vue?vue&type=script&lang=js"
export * from "./PortcallinvoicesModals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports